export default __webpack_public_path__ + "static/media/C6.25d55dac.png";